/* script */
//
//
//
//
//
//

// Utils
import { isFunction } from 'lodash';
import { mapGetters, mapMutations } from 'vuex';

// Components
import LiveStreamForm from 'ui/pages/live-stream/LiveStreamForm.vue';

const LIVE_STREAM_STORE = 'liveSession/liveStream';

/**
 * This components shows the live stream create/edit page.
 *
 * @vue-prop {Object} params the page configuration parameters.
 *
 * @category ui.pages.live-streams
 * @exports LiveStream
 * @component
 */
const __vue_script__ = {
    name: 'LiveStream',

    components: {
        LiveStreamForm,
    },

    props: {
        params: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            showForm: false,
            eventId: this.params.event.id,
        };
    },

    computed: {
        ...mapGetters(LIVE_STREAM_STORE, [
            'liveStream',
            'liveStreamId',
        ]),
    },

    async created() {
        const liveStreamId = this.getLiveStreamId();
        if (!liveStreamId || liveStreamId === 'new') {
            this.showForm = true;
            return;
        }

        // redirect to studio or show form
        if (!this.redirectToStudioApp()) {
            this.showForm = true;
        }
    },

    destroyed() {
        // cleanup the live stream ID from the store if going back to the list
        const liveStreamId = this.getLiveStreamId();
        if (!liveStreamId) {
            this.cleanLiveStreamId();
        }
    },

    methods: {
        ...mapMutations(LIVE_STREAM_STORE, [
            'setLiveStream',
            'cleanLiveStreamId',
        ]),

        getLiveStreamId() {
            return isFunction(this.$router.getRouteParams) ? this.$router.getRouteParams().modelId : this.params.liveStreamId;
        },

        /**
         * User's force-disconnected handler
         */
        onLeave() {
            this.unregisterFromSignals();
        },

        getLiveSessionLocation() {
            const path = window.location.pathname;
            let params;

            if (path) {
                params = path.match(/^\/event\/(.*)\/live_streams\/(.*)/);
            }

            if (params && params.length > 2) {
                return `${this.$const.STUDIO_EXPRESS_BASE_PATH}/${params[1]}/${params[2]}`;
            }
        },

        redirectToStudioApp() {
            const liveSessionLocation = this.getLiveSessionLocation();
            if (!liveSessionLocation) {
                return false;
            }

            // we've been summoned from legacy link live-stream package with event link, redirect to proper url
            window.location.replace(liveSessionLocation);
            return true;
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"live-stream-detail",class:{'has-loader': !_vm.showForm}},[(_vm.showForm)?_c('live-stream-form',{attrs:{"event":_vm.params.event}}):_vm._e(),_c('loader',{staticClass:"in-page live-stream-redirect",attrs:{"status":!_vm.showForm}})],1)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "LiveStream.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__